import script from "./StatementsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementsView.vue?vue&type=script&setup=true&lang=js"

import "./StatementsView.vue?vue&type=style&index=0&id=09847e80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09847e80"]])

export default __exports__